export type OcrProgress = { status: string; progress: number };

export async function recognizeRosterImage(file: File, onProgress?: (value: OcrProgress) => void) {
  const { createWorker } = await import("tesseract.js");
  const worker = await createWorker("eng", 1, {
    logger: (message) => onProgress?.({ status: String(message.status || "OCR"), progress: Number(message.progress || 0) }),
  });
  try {
    const result = await worker.recognize(file);
    return String(result.data.text || "")
      .split(/\r?\n/)
      .map((line) => line.replace(/^\s*\d+[.)-]?\s*/, "").trim())
      .filter(Boolean)
      .join("\n");
  } finally {
    await worker.terminate();
  }
}
